export const CounterItemCollapsedIcon = Object.freeze({
	CHAT_CHECK: 'chat-chek',
});
